<template>
  <article>
    <section class="xbed-sub-title">
      <span>延迟退房订单</span>
    </section>
    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>订单管理</BreadcrumbItem>
        <BreadcrumbItem>延迟退房订单</BreadcrumbItem>
      </Breadcrumb>
    </section>
    <Form class="add-distance" :model="formItem" inline size="small">
<!--       <formItem>
        <Row>
          <Col span="9">
          <Select v-model="value" disabled>
            <Option v-for="(item, idx) in option" :key="idx" :value="item.value">{{ item.label }}</Option>
          </Select>
          </Col>
          <Col span="1" style="text-align: center;">-
          </Col>
          <Col span="9">
          <DatePicker v-model="value2" format="yyyy/MM/dd" type="daterange" placement="bottom-end"
            placeholder="Select date" style="width: 200px" />
          </Col>
        </Row>
      </formItem>
 -->      
      <formItem label="延迟退房时间：" :label-width="120">
        <DatePicker v-model="value2" format="yyyy/MM/dd" type="daterange" placement="bottom-end"
            placeholder="Select date" style="width: 230px" />
      </formItem>
      <formItem label="订单号：" :label-width="90">
        <Input v-model="orderNo" placeholder="订单号" />
      </formItem>
      <formItem label="房间号：" :label-width="90">
        <Input v-model="roomNo" placeholder="房间号" />
      </formItem>
      <FormItem label="门店名称：" :label-width="120">
          <Select ref="resetChain" v-model="chainId" clearable filterable placeholder="id/名称 输入下拉选择" style="width:230px;">
            <Option v-for="(item, index) in allChains" :value="item.chainId" :key="index">{{ `${item.chainId}_${item.chainName}` }}</Option>
          </Select>
      </FormItem>
      <formItem label="申请人：" :label-width="90">
        <Input v-model="orderName" placeholder="申请人" />
      </formItem>
      <formItem>
        <Button type="primary" @click="queryList">查询
        </Button>
      </formItem>
    </Form>
    <Table stripe :columns="columns" :data="tableData" :loading="consumloading"></Table>
    <Page show-sizer placement="top" style="margin-top:10px" :total="orderList.count" :current="orderList.page" :page-size="orderList.pageSize" @on-page-size-change="changePageSize" @on-change="changePage" show-elevator></Page>
  </article>
</template>

<script>
import Moment from "moment";
import Utils from "@/utils";
import API from "../../api";
export default {
  data() {
    return {
      consumloading: false,
      tableData: [],
      orderName: "",
      roomNo: "",
      orderNo: "",
      orderList: {
				count: 0,
				pageCount: 0, //页面总数
				page: 1, // 第几页
				pageSize: 10, // 每页数量
				loading: false,
				data: []
			},
      columns: [
        {
          title: '门店',
          key: 'hotelName',
          width: 200,
          align: 'center'
        },
        {
          title: '订单号',
          key: 'orderNo',
          width: 200,
          align: 'center',
          render: ( h, params ) => {
						return h(
							"a",
							{
								on: {
									click: () => {
										if ( this.$router ) {
											this.$router.push( {path: "/app/order/orderDetail", query: {orderNo: params.row.orderNo, checkinId: params.row.checkinId}} );
										} else {
											window.open( `#/Order/Reserve/newOrderDetailView?orderNo=${ params.row.orderNo }&checkinId=${ params.row.checkinId }` );
										}
									}
								}
							},
							params.row.orderNo
						);
					}
        },
        {
          title: '房间',
          key: 'roomName',
          width: 200,
          align: 'center'
        },
        {
          title: '订单来源',
          key: 'orderSourceName',
          width: 200,
          align: 'center'
        },
        {
          title: '订单创建时间',
          key: 'checkInCreateTime',
          width: 200,
          align: 'center'
        },
        {
          title: '延迟退房申请时间',
          key: 'delayAppleTime',
          width: 200,
          align: 'center'
        },
        {
          title: '延迟退房时间',
          key: 'delayCheckoutTime',
          width: 200,
          align: 'center'
        },
        {
          title: '申请人',
          key: 'userName',
          width: 200,
          align: 'center'
        },
        {
          title: '预退房时间',
          key: 'checkoutTime',
          width: 200,
          align: 'center'
        },
        {
          title: '实际退房时间',
          key: 'actualCheckoutTime',
          width: 200,
          align: 'center'
        },
        {
          title: '延迟后实际退房时间',
          key: 'delayActualCheckoutTime',
          width: 200,
          align: 'center'
        },
        {
          title: '房间密码',
          key: 'doorPassword',
          width: 200,
          align: 'center'
        },
        {
          title: "操作", key: 'action',
          width: 100,
          align: 'center',
          render: (h,params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary'
                },
                on: {
                  click: () => {
                    if ( this.$router ) {
											this.$router.push( {path: "/app/order/orderDetail", query: {orderNo: params.row.orderNo, checkinId: params.row.checkinId}} );
										} else { 
											window.open( `#/Order/Reserve/newOrderDetailView?orderNo=${ params.row.orderNo }&checkinId=${ params.row.checkinId }` );
										}
                    // window.location.href = `#/Order/Reserve/newOrderDetailView?orderNo=${param.row.orderNo}`
                  }
                }
              }, '详情')
            ]);
          }
        }
      ],
      value3: "",
      page: 1,
      formItem: {},
      chainId: "",
      value: "1",
      value2: [Moment().format('YYYY-MM-DD'),
      Moment().add(1, 'days').format('YYYY-MM-DD')],
      allCities: [],
      allHotSpots: [],
      allChains: [],
      option: [
        { label: "延迟退房时间", value: "1" }
      ]
    }
  },
  created() {
    // this.env = 'dev'
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.headerENV = Utils.aliHeaderEnv(this.env)
    this.AuthorToken = Utils.findFromLocalStorage('Author-token');
    this.queryOrderDataByDateExt()

  },
  async mounted() {
    this.getChainData();
  },
  methods: {
    changePage( pageIndex ) {
			this.orderList.page = pageIndex;
			this.queryOrderDataByDateExt();
		},
		changePageSize( pageSize ) {
			this.orderList.page = 1;
			this.orderList.pageSize = pageSize;
			this.queryOrderDataByDateExt();
		},
    queryList() {
      // debugger
      this.value2 = [Moment(this.value2[0]).format('YYYY-MM-DD'), Moment(this.value2[1]).format('YYYY-MM-DD')]
      this.page = 1
      this.queryOrderDataByDateExt()
    },
    async queryOrderDataByDateExt() {
      const [delayCheckoutMinTime, delayCheckoutMaxTime] = this.value2
      const param = {
        delayCheckoutMinTime: delayCheckoutMinTime + " 00:00:00",
        delayCheckoutMaxTime: delayCheckoutMaxTime + " 23:59:59",
        chainId: this.chainId,
        page: this.orderList.page,
        size: this.orderList.pageSize
      }
      if(this.orderNo){
        param.orderNo = this.orderNo
      }
      if(this.roomNo){
        param.roomNo = this.roomNo
      }
      if(this.orderName){
        param.orderName = this.orderName
      }
      const res = (await API.omsAPI[this.env].clientServer.getLateCheckOrderList(param, { 'isForm': true,'x-ca-stage': this.headerENV, 'Content-Type': 'application/json;charset=UTF-8', 'Authorization': this.AuthorToken })).data;
      if (res.list)
        this.tableData = res.list
      this.orderList.count = res.total
    },
    // 获取所有门店数据
    async getChainData () {
      const resp = (await API.omsAPI[this.env].cleaner.queryChainListForCleanOrder(this.token)).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: "查询门店列表失败",
          desc: resp.msg
        });
        return
      }
      this.allChains = resp;
    },
  }
}
</script>

<style lang="scss" scoped>
.add-distance {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/order/late-check-out-order.vue